import { FormattedMessage, FormattedNumber } from 'react-intl';

interface Props {
  sgPosition: number;
  numberOfIssuers: number;
}

export function SgPositioningReadonly({ sgPosition, numberOfIssuers }: Props) {
  return (
    <div className="d-flex flex-wrap gap-2">
      <div className="text-large">
        <FormattedMessage id="missedDealFeedback.sgPositioningBefore" />
      </div>
      <div className="fw-bold text-info">
        <FormattedNumber value={sgPosition} />
      </div>
      <div>
        <FormattedMessage id="missedDealFeedback.sgPositioningMiddle" />
      </div>
      <div className="fw-bold text-info">
        <FormattedNumber value={numberOfIssuers} />
      </div>
      <div>
        <FormattedMessage id="missedDealFeedback.sgPositioningAfter" />
      </div>
    </div>
  );
}
